import {IRoutableModule} from '../../router/routing.infra';
import {MultipartyDashboardView} from './multipartyDashboard.view';
import {multipartyDashboardRouteLoader} from './multipartyDashboard.loader';

export default {
    loader: multipartyDashboardRouteLoader,
    Component: MultipartyDashboardView,
    storeAs: 'multipartyDashboardStore'
} as IRoutableModule;
